import { render, staticRenderFns } from "./IconSelector.vue?vue&type=template&id=7f72eded&scoped=true"
import script from "./IconSelector.vue?vue&type=script&lang=ts"
export * from "./IconSelector.vue?vue&type=script&lang=ts"
import style0 from "./IconSelector.vue?vue&type=style&index=0&id=7f72eded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f72eded",
  null
  
)

export default component.exports